import React, { useEffect } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import { navigate } from '@gatsbyjs/reach-router';

export const PlaidModalLoader = ({
  linkToken,
  onPlaidSuccess,
  onPlaidReady,
  onPlaidError,
  isOauth,
  displayAmountConfirmationModal = false,
  basepath,
  orderId,
}) => {
  const onExit = async () => {
    await navigate(`${basepath}orders/${orderId}/payments`);
  };

  const config = {
    token: linkToken,
    onSuccess: onPlaidSuccess,
    onExit: onExit,
  };
  const { open, ready, error } = usePlaidLink(config);

  if (isOauth) {
    config.receivedRedirectUri = window.location.href;
  }

  useEffect(() => {
    const hasOauthRenderedOnce = localStorage
      .getItem('hasOauthRenderedOnce')
      ?.toLowerCase();

    if (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      onPlaidError();
    } else if (isOauth && ready && hasOauthRenderedOnce !== 'true') {
      // There is an analytics.js hook several parent nodes up that is causing
      // This component to re-render and call Plaid's open() twice.
      // Since that breaks the Plaid integration, we had to use a localStorage
      // flag to block it from calling open() twice.
      localStorage.setItem('hasOauthRenderedOnce', 'true');
      open();
    } else if (ready && displayAmountConfirmationModal) {
      open();
      onPlaidReady();
    }
  }, [ready, open, isOauth, linkToken, displayAmountConfirmationModal, error]);

  return <></>;
};
